import SmartTable from "@webkit/components/SmartTable.js"

const AccomodationList = () => {

    return (
        
        <SmartTable />
        
    )
}

export default AccomodationList